import { TABLE_PER_PAGES_OPTIONS, SORTING_ORDERS } from "@/constants";
/**
 * State
 * @description This module manages,stores and persits the user selected settings
 * in the application ui screens
 */
const state = {
  // Manage seed view settings
  seeds: {
    sort_by: null,
    sort_order: SORTING_ORDERS.desc,
    itemsPerPage: TABLE_PER_PAGES_OPTIONS[1],
    itemsPerPageOptions: TABLE_PER_PAGES_OPTIONS,
  },
};

/**
 * Mutation constants
 */
const SET_SEEDS_SETTINGS = "SET_SEEDS_SETTINGS";
/**
 * Mutations
 */
const mutations = {
  [SET_SEEDS_SETTINGS](state, data) {
    const updatedSettings = { ...state.seeds, ...data };
    state.seeds = updatedSettings;
  },
};

/**
 * Actions
 */
const actions = {
  setSeedsSettings({ commit }, settings) {
    commit(SET_SEEDS_SETTINGS, settings);
  },
};
/**
 * Getters
 */
const getters = {
  seeds({ seeds }) {
    return seeds;
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced: true,
};
